import { render, staticRenderFns } from "./SusutForm.vue?vue&type=template&id=2f1dbe5b&"
import script from "./SusutForm.vue?vue&type=script&lang=js&"
export * from "./SusutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports